import Recipients from './RecipientsList';

export default Recipients;
